/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { getCustomDomain } from "../../util/CustomDomain";
import makeRequest from "../MakeRequest";
import { parseLoginResponse, parseLoginVerifyResponse } from "./Parsers";

export const requestLogin = (attrs) => {
  // prepare payload
  const { type, email, sms } = attrs;
  const payload = {
    type: type,
    email: email,
    sms: sms,
  };

  // make request
  makeRequest({
    ...attrs,
    request: {
      route: "guest/data/login/verification",
      payload: payload,
      parser: parseLoginResponse
    }
  });
};

export const requestLoginVerify = (attrs) => {
  // prepare payload
  const { type, email, sms, code } = attrs;
  const payload = {
    type: type,
    email: email,
    sms: sms,
    code: code,
  };

  // make request
  makeRequest({
    ...attrs,
    request: {
      route: "guest/data/login/verify",
      payload: payload,
      parser: parseLoginVerifyResponse
    }
  });
};

export const requestLoginTokenVerify = (attrs) => {
  // get token
  const { token } = attrs;

  // make request with token
  makeRequest({
    ...attrs,
    request: {
      route: "guest/data/token/verify",
      token: token,
      parser: parseLoginVerifyResponse
    }
  })
};